import type { OrganizationSiteProfile } from 'types/organization-site';

export interface GoodfyndSiteContextValue {
  currentLocation?: OperatingDayLocation;
  currentPickupLocation?: OperatingDayLocation;
  isFetchingAppointments: boolean;
  isPreview: boolean;
  locations: OperatingDayLocation[];
  orderingLocations: OperatingDayLocation[];
  organization: OrganizationSiteProfile;
  publicLocations: OperatingDayLocation[];
  slug: string;
}

export enum GoodfyndSiteSection {
  AboutUs = 'about-us',
  BusinessInfo = 'business-info',
  ContactUs = 'contact-us',
  Home = 'home',
  Schedule = 'schedule',
}
export interface GoodfyndSiteDispatchContextValue {
  setCurrentPickupLocation: React.Dispatch<
    React.SetStateAction<OperatingDayLocation | undefined>
  >;
}

export interface GoodfyndSiteProviderProps {
  children: React.ReactNode;
  organization: OrganizationSiteProfile;
}
